import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=2903679c&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=2903679c&prod&scoped=true&lang=css"
import style1 from "./RegisterPage.vue?vue&type=style&index=1&id=2903679c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903679c",
  null
  
)

export default component.exports